import {Stack, Text, useTheme} from '@fluentui/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {useCommand} from 'hooks';
import {v4 as uuidv4} from 'uuid';

export const SearchTopNumber: React.FC<{
	currentTop: number;
	setCurrentTop: (currentTop: number) => void;
}> = ({currentTop, setCurrentTop}) => {
	const {t} = useTranslation('features/search');
	const theme = useTheme();

	const optionsTopSugg = [25, 100, 500];

	useCommand(
		{
			key: uuidv4(),
			priority: 1,
			commandBarButtonAs(): JSX.Element {
				return (
					<Stack horizontal>
						<Text style={{paddingTop: 12, marginLeft: 15}}>
							{t('MaxTopSugg')}
						</Text>
						<Stack
							horizontal
							style={{
								marginLeft: 10,
								marginRight: 10,
								background: theme.palette.neutralLight,
								borderRadius: 5,
							}}
						>
							{optionsTopSugg.map(x => (
								<button
									key={uuidv4()}
									style={{
										cursor: 'pointer',
										padding: 10,
										margin: 5,
										borderRadius: 5,
										border: 0,
										background:
											currentTop === x ? theme.palette.themeLighter : undefined,
									}}
									onClick={() => setCurrentTop(x)}
								>
									{x}
								</button>
							))}
						</Stack>
					</Stack>
				);
			},
		},
		[currentTop],
	);
	return <></>;
};
